import { useClientEnvironment } from "~/environment/ClientEnvironmentContext";
import { useObservableEagerState } from "observable-hooks";

export function useIsPendingUpdate() {
  const environment = useClientEnvironment();
  return useObservableEagerState(environment.isPendingUpdate.isUpdating$);
}
